import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import DataExportList from "reports/data-export/data-export-list/components/DataExportList";
import ReportsMessages from "reports/intl/ReportsMessages";

export const getTabs = (formatMessage) => {
  const tabs = [
    {
      key: "data-export",
      content: <DataExportList />,
      name: formatMessage(ReportsMessages.myReports),
      path: "/data-export",
    },
  ];

  return tabs;
};

const useReportsModuleTabs = () => {
  const { formatMessage } = useIntl();
  const tabs = useMemo(() => getTabs(formatMessage), [formatMessage]);

  return tabs;
};

export default useReportsModuleTabs;
